import { atom } from "jotai";

import { UpdateCustomerRoundInput } from "../../../../../hooks/saveChangesHooks/useSaveChangesToSingleSlotBooking/__generated__/useSaveChangesToSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedCustomerRoundsAtom = atom<
  UpdateCustomerRoundInput[] | null
>((get) => {
  const currentBooking = get(currentBookingAtom);
  if (!currentBooking) return null;
  const rounds = currentBooking.rounds;
  const customerRounds = rounds?.filter(
    (r) =>
      r.player?.clientType === "customer" ||
      r.player?.clientType === "unknownCustomer"
  );
  const input: UpdateCustomerRoundInput[] = customerRounds?.map((r) => ({
    index: r.index,
    bookingIndex: r.bookingIndex,
    id: r.serverId,
    playerId: r.player?.id || null,
    courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
    transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
    secondaryTransportationTypeId: r.secondaryTransportationType?.id,
    rateId: r.type === "Golf" ? r.roundRate?.id : r.rate?.id ?? null,
  }));
  return input;
});
